export const product = [
  {
    rating: 5,
    numReviews: 11,
    price: 6499.99,
    countInStock: 5,
    _id: "i1360df749a5027923750d79730",
    name: "ايفون 13 برو   جديد",
    image: "/iphone13pro.jpg",
    images: ["iphone-13-1.webp", "iphone-13-3.webp", "iphone-13-4.webp"],
    size: [128, 256, 512],
    description: "intuitive design",
    brand: "appel",
    category: "Electronics",
    user: "60df74995027923750d7972b",
    avilabel: true,
  },
  {
    rating: 4.272727272727273,
    numReviews: 11,
    price: 4499.99,
    countInStock: 5,
    _id: "60df749a2550270d79730",
    name: "ايفون 12 برو ماكس",
    image: "/iphone12.webp",
    description: " intuitive design",
    brand: "appal",
    category: "Electronics",
    user: "60df74995027923750d7972b",
    avilabel: true,
  },
  {
    rating: 4.5,
    numReviews: 11,
    price: 3999.99,
    countInStock: 5,
    _id: "60d500d730",
    name: "ايفون 11",
    image: "/iphone11.jpg",
    images: ["iphone-13-1.webp", "iphone-13-3.webp", "iphone-13-4.webp"],
    description: "intuitive design",
    brand: "Cannon",
    category: "Electronics",
    user: "60df74995027923750d7972b",
    avilabel: true,
  },
];
export const fProduct = [
  {
    _id: "55sdf53",
    name: "ابل ايفون 13 برو ماكس سعة256 جيجابايت ، الجيل الخامس 5G ،لون أزرق",
    images: ["/images/1631924930_8580.jpg"],
    price: 5300,
    subprice: 5200,
    discount: 2,
    category: "iphone13",
  },

  {
    _id: "846325",
    name: "أيفون 11 برو 256 جيجابايت الدفعه الاولى 1000 ريال",
    images: ["/images/1625529888_6819.jpg"],
    price: 3900,
    subprice: 3600,
    description: "الدفعة الاولى 1000 ريال والقسط الشهري 108 ريال على 24 شهر",
    discount: 8,
    category: "apple",
  },
  {
    rating: 5,
    price: 2000.99,
    countInStock: 5,
    _id: "edf749a5027923750d79730",
    name: "سوني بلاي ستيشن 5 (حزمه )",
    images: [
      "/playstations/ply1.jpg",
      "/playstations/ply1.2.jpg",
      "/playstations/ply1.3.jpg",
      "/playstations/ply1.4.jpg",
    ],
    description:" ",
    ddescription:
      "استمتع بتجربة لعب سلسة ومُرضية بمعدَّل إطار مرتفع يصل إلى 120 إطارًا في الثانية للألعاب المتوافقة مع دعم للإخراج بمعدَّل 120 هرتز على عروض بدقة 4K.",
    category: "Electronics",
    user: "60df74995027923750d7972b",
    avilabel: true,
  },
  {
    rating: 5,
    price: 2500.99,
    countInStock: 5,
    _id: "60kk9khha5027923750730",
    name: "بلاي ستيشين 5، ديجتال، مع أداة تحكم إضافية بلون أسود",
    images: ["/playstations/ply2.1.jpg", "/playstations/ply2.2.jpg"],
    description:" ",
    ddescription:
      "سريع وهادئ وفعال. يشعر بالسعادة لوجوده في جيل وحدة تحكم جديد، لقد مضى وقت طويل. وحدة التحكم الجديدة رائعة، واجهة المستخدم الجديدة تتميز بكونها مدروسة بعناية فائقة وسريعة الاستجابة. الألعاب الجديدة رائعة.",
    category: "Electronics",
    user: "60df95027923750d7972b",
    avilabel: true,
  },
  {
    _id: "8749520213",
    name: "ايفون 11 128 جيجابايت الدفعه الاولى 1000 ريال",
    images: ["/images/1625527781_7524.jpeg"],
    price: 3500,
    subprice: 3200,
    description: "الدفعة الاولى 1000 ريال والقسط الشهري 92 ريال على 24 شهر",
    discount: 9,
    category: "apple",
  },
  {
    rating: 5,
    numReviews: 11,
    price: 2299.99,
    countInStock: 5,
    _id: "60df749a5jkgghjl027d79730",
    name: "بلاي ستيشين 5 ديجتال، مع سماعة لا سلكية",
    images: ["/playstations/ply4.jpg"],
    description:" ",
    ddescription:
      "انغمس في عوالم تتميّز بمستوى جديد من الواقعية حيث تتم محاكاة أشعة الضوء بشكل فردي، مما يخلق ظلالًا وانعكاسات واقعية في ألعاب PS5 المدعومة. شغّل ألعاب PS5 التي تفضِّلها على تلفزيونك بدقة 4K.",
    brand: "appel",
    category: "Electronics",
    user: "60df749950279237572b",
    avilabel: true,
  },
];

export const SonyProduct = [
  {
    rating: 5,
    numReviews: 11,
    price: 2400.0,
    countInStock: 5,
    _id: "60df749a5jkgghjl027d79730",
    name: "بلاي ستيشن 5 سي دي مع سماعة و يد تحكم إضافية ",
    images: ["/playstations/ply4.jpg"],
    description:" ",
    ddescription:
      "انغمس في عوالم تتميّز بمستوى جديد من الواقعية حيث تتم محاكاة أشعة الضوء بشكل فردي، مما يخلق ظلالًا وانعكاسات واقعية في ألعاب PS5 المدعومة. شغّل ألعاب PS5 التي تفضِّلها على تلفزيونك بدقة 4K.",
    brand: "appel",
    category: "Electronics",
    user: "60df749950279237572b",
    avilabel: true,
  },
  {
    rating: 5,
    price: 2000.0,
    countInStock: 5,
    _id: "edf749a5027923750d79730",
    name: "سوني بلاي ستيشن 5 نسخة الديجيتال",
    images: [
      "/playstations/ply1.jpg",
      "/playstations/ply1.2.jpg",
      "/playstations/ply1.3.jpg",
      "/playstations/ply1.4.jpg",
    ],
    description:" ",
    ddescription:
      "استمتع بتجربة لعب سلسة ومُرضية بمعدَّل إطار مرتفع يصل إلى 120 إطارًا في الثانية للألعاب المتوافقة مع دعم للإخراج بمعدَّل 120 هرتز على عروض بدقة 4K.",
    category: "Electronics",
    user: "60df74995027923750d7972b",
    avilabel: true,
  },
  {
    rating: 5,
    price: 2300.0,
    countInStock: 5,
    _id: "60kk9khha5027923750730",
    name: "بلاي ستيشين 5، ديجتال، مع يد تحكم إضافية بلون أسود",
    images: ["/playstations/ply2.1.jpg", "/playstations/ply2.2.jpg"],
    description:" ",
    ddescription:
      "سريع وهادئ وفعال. يشعر بالسعادة لوجوده في جيل وحدة تحكم جديد، لقد مضى وقت طويل. وحدة التحكم الجديدة رائعة، واجهة المستخدم الجديدة تتميز بكونها مدروسة بعناية فائقة وسريعة الاستجابة. الألعاب الجديدة رائعة.",
    category: "Electronics",
    user: "60df95027923750d7972b",
    avilabel: true,
  },
  {
    rating: 5,
    numReviews: 11,
    price: 1100.0,
    countInStock: 5,
    _id: "60df749a5027d75549730",
    name: "بلاي ستيشين 4، 500 جيجا، مع 3 ألعاب",
    description:" ",
    images: [
      "/playstations/ply3.1.jpg",
      "/playstations/ply3.2.jpg",
      "/playstations/ply3.3.jpg",
      "/playstations/ply3.4.jpg",
    ],
    ddescription:
      "اختبر أحداث اللعبة بطرق جديدة مذهلة مع PS4 وPS VR. ما عليك سوى توصيل سماعة رأس PS VR بـ PS4 للانغماس في ألعاب الواقع الافتراضي التي تخطف الأنفاس والتجارب والترفيه.",
    brand: "appel",
    category: "Electronics",
    user: "60df749950279237572b",
    avilabel: true,
  },
  {
    rating: 5,
    numReviews: 11,
    price: 2299.0,
    countInStock: 5,
    _id: "60df749a5jkgghjl027d79730",
    name: "بلاي ستيشين 5 ديجتال، مع سماعة لا سلكية",
    description:" ",
    images: ["/playstations/ply4.jpg"],
    ddescription:
      "انغمس في عوالم تتميّز بمستوى جديد من الواقعية حيث تتم محاكاة أشعة الضوء بشكل فردي، مما يخلق ظلالًا وانعكاسات واقعية في ألعاب PS5 المدعومة. شغّل ألعاب PS5 التي تفضِّلها على تلفزيونك بدقة 4K.",
    brand: "appel",
    category: "Electronics",
    user: "60df749950279237572b",
    avilabel: true,
  },
  {
    rating: 5,
    numReviews: 11,
    price: 2400.0,
    countInStock: 5,
    _id: "60df7027923779730",
    name: " بلاي ستيشين 5 ديجتال، مع يد تحكم وسماعة لاسلكية ",
    images: ["/playstations/ply5.jpg", "/playstations/ply5.1.jpg"],
    description:" ",
    ddescription:
      "سريع وهادئ وفعال. يشعر بالسعادة لوجوده في جيل وحدة تحكم جديد، لقد مضى وقت طويل. وحدة التحكم الجديدة رائعة، واجهة المستخدم الجديدة تتميز بكونها مدروسة بعناية فائقة وسريعة الاستجابة. الألعاب الجديدة رائعة.",
    brand: "appel",
    category: "Electronics",
    user: "60df74995027923750d7972b",
    avilabel: true,
  },
];
export const ApplePro = [
  {
    _id: "555822",
    name: "أبل آيفون XR مع فيس تايم",
    images: ["/images/1631561137_3804.jpg"],
    price: 2499,
    subprice: 2349,
    description: "الدفعة الاولى 800 ريال والقسط الشهري 65 ريال على 24 شهر",
    discount: 6,
    category: "apple",
  },
  {
    _id: "566844",
    name: "أبل هاتف آيفون XR بذاكرة داخلية",
    images: ["/images/1631560922_6864.jpg"],
    price: 2648,
    subprice: 2548,
    description: "الدفعة الاولى 800 ريال والقسط الشهري 73 ريال على 24 شهر",
    discount: 4,
    category: "apple",
  },
  {
    _id: "846325",
    name: "أيفون 11 برو 256 جيجابايت الدفعه الاولى 1000 ريال",
    images: ["/images/1625529888_6819.jpg"],
    price: 3900,
    subprice: 3600,
    description: "الدفعة الاولى 1000 ريال والقسط الشهري 108 ريال على 24 شهر",
    discount: 8,
    category: "apple",
  },
  {
    _id: "55sdf53",
    name: "ابل ايفون 13 برو ماكس سعة256 جيجابايت ، الجيل الخامس 5G ،لون أزرق",
    images: ["/images/1631924930_8580.jpg"],
    price: 5300,
    subprice: 5200,
    description: "",
    discount: 2,
    category: "iphone13",
  },
  {
    _id: "eg45524",
    name: "أيفون 13 برو 128 جيجابايت ، الجيل الخامس - ذهبي",
    images: ["/images/1631889348_7800.jpeg"],
    price: 4849,
    subprice: 4749,
    description: "",
    discount: 2,
    category: "iphone13",
  },
  {
    _id: "522528fds",
    name: "آبل أيفون 12 ، 128 جيجا الدفعه الاولى 1000 ريال",
    images: ["/images/1625526457_2075.jpeg"],
    price: 4500,
    subprice: 4200,
    description: "الدفعة الاولى 1000 ريال والقسط الشهري 133 ريال على 24 شهر",
    discount: 7,
    category: "apple",
  },
  {
    _id: "518ca0",
    name: "آبل أيفون 12 برو ، 128 جيجا الدفعه الاولى 1000 ريال",
    images: ["/images/1625526136_5613.jpg"],
    price: 4600,
    subprice: 4400,
    description: "الدفعة الاولى 1000 ريال والقسط الشهري 142 ريال على 24 شهر",
    discount: 4,
    category: "apple",
  },
  {
    _id: "8749520213",
    name: "ايفون 11 128 جيجابايت الدفعه الاولى 1000 ريال",
    images: ["/images/1625527781_7524.jpeg"],
    price: 3500,
    subprice: 3200,
    description: "الدفعة الاولى 1000 ريال والقسط الشهري 92 ريال على 24 شهر",
    discount: 9,
    category: "apple",
  },
];

export const Ipads= [
  {
    _id:"125551827",
    name:'آي باد برو 2021 (الجيل الثالث) بــ4910 ر.س',
    images:['/1631478493_8097.jpg'],
    price:1666,
    subprice:1616,
    description:"الدفعة الاولى 500 ريال والقسط الشهري 47 ريال على 24 شهر",
    discount:3,
    category:'ipad',
},
  {
    _id:"120000005527",
    name:'آي باد برو 2021 (الجيل الثالث) بــ4910 ر.س',
    images:['/1625601157_7353.jpg'],
    price:1666,
    subprice:1616,
    description:"الدفعة الاولى 500 ريال والقسط الشهري 47 ريال على 24 شهر",
    discount:3,
    category:'ipad',
},
  {
    _id:"125527",
    name:'أبل جهاز آي باد- 2019 من الجيل السابع',
    images:['/1631560568_1202.jpg'],
    price:1666,
    subprice:1616,
    description:"الدفعة الاولى 500 ريال والقسط الشهري 47 ريال على 24 شهر",
    discount:3,
    category:'ipad',
},
{
    _id:"215sc5ds",
    name:'آيباد آير ( الجيل الرابع) بشاشة 10.9 بوصة 265GB',
    images:['/1631559062_8588.jpg'],
    price:3399,
    subprice:3299,
    description:"الدفعة الاولى 1000 ريال والقسط الشهري 96 ريال على 24 شهر",
    discount:3,
    category:'ipad',
},
{
    _id:"jnhk1505",
    name:'سامسونج جالكسي تاب A7',
    images:['/1631558696_1477.jpg'],
    price:1199,
    subprice:1000,
    description:"الدفعة الاولى 500 ريال والقسط الشهري 21 ريال على 24 شهر",
    discount:17,
    category:'ipad',
},
{
    _id:"50d452105",
    name:'سامسونج جالاكسي تاب S2 إصدار',
    images:['/1631558625_3479.jpg'],
    price:1399,
    subprice:1299,
    description:"الدفعة الاولى 500 ريال والقسط الشهري 33 ريال على 24 شهر",
    discount:7,
    category:'ipad',
},
]

export const Hproducts = [
  {
    _id: "55sd8084f53",
    name: "ابل ايفون 13 برو ماكس  سعة256 جيجابايت ، الجيل الخامس 5G ،لون روز",
    images: ["/images/1625499702_8715.jpg"],
    price: 5300,
    subprice: 5200,
    description: " ",
    discount: 2,
    category: "iphone13",
    avilabel: true
  },
  {
    _id: "55sd180f53",
    name: "ابل ايفون 13 برو ماكس سعة256 جيجابايت ، الجيل الخامس 5G ،لون أزرق",
    images: ["/images/1631888591_6916.jpeg"],
    price: 5300,
    subprice: 5200,
    description: " ",
    discount: 2,
    category: "iphone13",
    avilabel: true
  },
  {
    rating: 5,
    price: 2000.0,
    countInStock: 5,
    _id: "edf749a5027923750d79730",
    name: "سوني بلاي ستيشن 5 نسخة الديجتال ",
    images: [
      "/playstations/ply1.jpg",
      "/playstations/ply1.2.jpg",
      "/playstations/ply1.3.jpg",
      "/playstations/ply1.4.jpg",
    ],
    description:
      "استمتع بتجربة لعب سلسة ومُرضية بمعدَّل إطار مرتفع يصل إلى 120 إطارًا في الثانية للألعاب المتوافقة مع دعم للإخراج بمعدَّل 120 هرتز على عروض بدقة 4K.",
    category: "Electronics",
    user: "60df74995027923750d7972b",
    avilabel: true,
  },
  {
    _id:"125527",
    name:'أبل جهاز آي باد- 2019 من الجيل السابع',
    images:['/1631560568_1202.jpg'],
    price:1666,
    subprice:1616,
    description:"الدفعة الاولى 500 ريال والقسط الشهري 47 ريال على 24 شهر",
    discount:3,
    category:'ipad',
},
];

export const AllProduct = [...ApplePro,...Hproducts,...Ipads, ...SonyProduct];
